/* eslint-disable @typescript-eslint/consistent-type-assertions -- conditional return в функциях не работает без type assertions */
import { hasUnicode } from './hasUnicode';
import { stringToArray } from './stringToArray';
/**
 * Создает функцию для изменения регистра первого символа строки
 * @param methodName Название метода для изменения регистра: 'toLowerCase' или 'toUpperCase'
 * @returns Функция, которая принимает строку и возвращает её с измененным регистром первого символа
 *
 * @example
 * // Создает функцию для приведения первого символа к нижнему регистру
 * const lowerFirst = createCaseFirst('toLowerCase');
 * lowerFirst('Hello World'); // -> 'hello World'
 *
 * @example
 * // Создает функцию для приведения первого символа к верхнему регистру
 * const upperFirst = createCaseFirst('toUpperCase');
 * upperFirst('hello world'); // -> 'Hello world'
 */
export function createCaseFirst(methodName) {
    return (dataString) => {
        if (!dataString) {
            return '';
        }
        const strSymbols = hasUnicode(dataString) ? stringToArray(dataString) : undefined;
        const chr = strSymbols ? strSymbols[0] : dataString[0];
        if (!chr) {
            return '';
        }
        const trailing = strSymbols ? strSymbols.slice(1).join('') : dataString.slice(1);
        return (chr[methodName]() + trailing);
    };
}
